export class BaseTokenService {

  protected id = '';

  constructor() { }

  public setToken(token: string): void {
    localStorage.setItem(this.id + '_auth_token', token);
  }

  public getToken(): string {
    return localStorage.getItem(this.id + '_auth_token');
  }

  public removeToken(): void {
    localStorage.removeItem(this.id + '_auth_token');
  }

  public setRefreshToken(token: string): void {
    localStorage.setItem(this.id + '_refresh_token', token);
  }

  public getRefreshToken(): string {
    return localStorage.getItem(this.id + '_refresh_token');
  }

  public removeRefreshToken(): void {
    localStorage.removeItem(this.id + '_refresh_token');
  }

  public isLoggedIn(): boolean {
    return this.isValidToken();
  }

  public getPayload(): any {
    const token = this.getToken();
    if (token){
      const payload = this.payload(token);
      if (payload) {
        return payload;
      }
    }
    return null;
  }

  private isValidToken(): boolean {
    return this.getPayload() !== null;
  }

  private payload(token: string): any {
    const jwtPayload = token.split('.')[1];
    return JSON.parse(atob(jwtPayload));
  }

}
